import React from "react";
import { MdEmail } from "react-icons/md";
import "./EmailButton.css";

const EmailButton = () => {
  const emailAddress = "info@crpnoctem.co.za";
  const subject = "Inquiry for CRP Noctem";
  const body = "Hello, I would like to know more about your services.";

  return (
    <button
      onClick={() => window.location.href = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}
      className="email-button"
    >
      <MdEmail size={20} />
      Email Us
    </button>
  );
};

export default EmailButton;


